'use es6';

import { VISITOR_SENDER } from 'conversations-message-history/common-message-format/constants/cmfSenderTypes';
import { getThreadId, getChannelName } from '../../threads/operators/threadGetters';
import { List as ImmutableList } from 'immutable';
import { publishMessageToConversation } from '../../actions/PublishActions/publishMessageToConversation';
import TypingIndicatorMessage from 'conversations-message-history/typing-indicator/records/TypingIndicatorMessage';
import { generateUuid } from 'conversations-message-history/util/generateUuid';
import { getSenderKeyFromType } from 'conversations-message-history/common-message-format/operators/getSenderKeyFromType';
import { SENT } from 'conversations-message-history/common-message-format/constants/statusTypes';
import { getMessagesUtk } from '../../query-params/getMessagesUtk';
import { LIVE_CHAT_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import { buildSenders } from 'conversations-message-history/common-message-format/operators/buildSenders';
import { CHANNEL_SPECIFIC_OPAQUE_ID } from 'conversations-message-history/common-message-format/constants/deliveryIdentifierTypes';
export const publishTypingMessage = ({
  thread
}) => dispatch => {
  const channel = getChannelName(thread);
  const threadId = getThreadId(thread);
  const senderType = VISITOR_SENDER;
  const senderTypeKey = getSenderKeyFromType(senderType);
  const senderId = getMessagesUtk();
  const deliveryIdentifier = {
    type: CHANNEL_SPECIFIC_OPAQUE_ID,
    value: senderId
  };
  const visitorTypingSender = ImmutableList([{
    deliveryIdentifier
  }]);
  const message = new TypingIndicatorMessage({
    id: generateUuid(),
    typingState: null,
    sender: {
      '@type': senderType,
      [senderTypeKey]: senderId
    },
    status: {
      messageStatus: SENT
    },
    genericChannelId: LIVE_CHAT_GENERIC_CHANNEL_ID,
    senders: buildSenders(visitorTypingSender)
  });
  dispatch(publishMessageToConversation({
    channel,
    message,
    threadId
  }));
};